import React, { useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import plus from "../../assets/images/product/plus.svg";
import TableBooking from "./tableBooking";
import iconExcel from "../../assets/images/employee/iconExcel.svg";
import AddBooking from "./formBooking/addBooking";
import { useBookingEvent } from "../../hooks/useBookingEvent";
import toast from "react-hot-toast";
import { bookingEventCall } from "../../api/bookingEvent";
import { exportFile } from "../../utils/tools";

export default function Booking() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [paramExport, setParamExport] = useState(null);

  const { refetch, isRefetching, entries, bookingEventData } =
    useBookingEvent();

  const handleExport = async () => {
    const checkInColumnMapping = {
      code: "MĐNBK",
      name: "Tên đợt booking",
      project: "Tên dự án",
      product: "Sản phẩm",
      startTime: "TG bắt đầu",
      endTime: "TG kết thúc",
      price: "Số tiền booking",
      creator: "Nhân viên tạo",
      createdAt: "Ngày tạo",
    };
    if (bookingEventData?.length) {
      const data = await bookingEventCall.export(entries, paramExport);
      if (data) {
        exportFile(data, checkInColumnMapping, "bang_dot_nhan_booking.xlsx");
        toast.success("Download file thành công");
      } else {
        toast.error("Không có dữ liệu");
      }
    } else toast.error("Không có dữ liệu");
  };

  const onSubmitAdd = async (data) => {
    const toastCreate = toast.loading("Đang thêm đợt nhận booking ...");
    try {
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null
        )
      );
      await bookingEventCall.create(filteredData);

      await refetch();
      onClose();
      toast.success("Thêm thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Đợt nhận booking
          </Text>
        </Flex>
        <Flex alignItems={"center"} gap={"16px"}>
          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            h={"44px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={handleExport}
          >
            <Image src={iconExcel} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất excel
            </Text>
          </Button>
          <Button
            w={"176px"}
            h={"44px"}
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            backgroundImage="var(--color-button)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={onOpen}
          >
            <Image src={plus} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              ĐN booking mới
            </Text>
          </Button>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableBooking
          isRefetchingWithCreate={isRefetching}
          paramData={setParamExport}
        />
      </Box>
      <AddBooking
        isOpen={isOpen}
        onClose={onClose}
        isEdit={false}
        onSubmit={onSubmitAdd}
      />
    </Box>
  );
}
